import React from "react";
import { AppState, RedirectLoginOptions } from "@auth0/auth0-react";

import LoginComponent from "../layout/LoginComponent";

const ProtectedComponent = ({
  children,
  isAuthenticated,
  loginWithRedirect,
}: {
  children: JSX.Element;
  isAuthenticated: boolean;
  loginWithRedirect: (options?: RedirectLoginOptions<AppState> | undefined) => Promise<void>;
}): JSX.Element => {
  return (
    <React.Fragment>{isAuthenticated ? children : <LoginComponent loginWithRedirect={loginWithRedirect} />}</React.Fragment>
  );
};

export default ProtectedComponent;
